export default __webpack_public_path__ + "static/media/spainBrand.3ddb5199.svg";